import { render, staticRenderFns } from "./infoRow.vue?vue&type=template&id=0bbabae7&scoped=true&"
import script from "./infoRow.vue?vue&type=script&lang=js&"
export * from "./infoRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbabae7",
  null
  
)

export default component.exports